"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.formatNumber = formatNumber;
var _parseFloat2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/parse-float"));
var _isNan = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/number/is-nan"));
/**
 * Formats a number via `Intl.NumberFormat` using the provided thousands and decimal separators.
 *
 * If you don't want to mess with said separators, just use `Intl.NumberFormat` directly.
 *
 * @param value The number to format
 * @param options The thousands and decimal separators, along with any options you would pass to Intl.NumberFormat
 * @returns A string representing the formatted number
 */
function formatNumber(value, options) {
  const number = typeof value === 'string' ? (0, _parseFloat2.default)(value) : value;
  if (typeof number !== 'number' && typeof number !== 'bigint' || (0, _isNan.default)(number)) {
    return '';
  }
  const {
    thousandsSeparator,
    decimalChar,
    ...intlNumberFormatOptions
  } = options;
  // Format number with 'en-US' so we know which characters to replace, i.e.
  // we will replace commas with thousandsSeparator, and decimals with decimalChar
  const localizedNumber = new Intl.NumberFormat('en-US', intlNumberFormatOptions).format(number);
  /**
   * Replace commas and decimals with the designated separators. This needs to
   * be done in one pass so we don't overwrite previous replacements. Chaining
   * `replace` calls will not work if `thousandsSeparator` is a period (".") or
   * `decimalChar` is a comma (","). Assuming both are true, this:
   *
   * return localizedNumber.replaceAll(',', thousandsSeparator).replace('.', decimalChar);
   *
   * would transform "1,234.56" into "1,234,56", when we wanted "1.234,56".
   */
  return localizedNumber.replace(/[,.]/g, match => match === ',' ? thousandsSeparator : decimalChar);
}